import { InjectionToken, inject } from '@angular/core';
import { IUserStore } from './user.public';
import { UserStore } from './user.store';

export const USER_STORE = new InjectionToken<IUserStore>('USER_STORE', {
    providedIn: 'root',
    factory: () => inject(UserStore) as IUserStore,
});
